/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const ON_VISIBILITY_SHOW_INFOCARD = 'ON_VISIBILITY_SHOW_INFOCARD';
export const ON_VISIBILITY_HIDE_INFOCARD = 'ON_VISIBILITY_HIDE_INFOCARD';
export const SET_INFOCARD_HIGHLIGHT = 'SET_INFOCARD_HIGHLIGHT';
